// `./amplify-init` MUST be the first import. Importing it triggers
// `Amplify.configure(amplify_outputs.json)` as a top-level side effect. The
// configure call has to run BEFORE any module that calls `generateClient()` at
// module-eval time -- DataContextProvider.tsx, pages/Applicant.tsx, and
// pages/TeacherView.tsx all do, transitively via `import App from "./App"`.
// See `amplify-init.ts`'s file header for the failure mode this prevents
// (#143 smoke-regression note `3374166197` on MR !42).
import { isPlaceholderConfig } from "./amplify-init";
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import CssBaseline from "@mui/material/CssBaseline";
import { Authenticator } from "@aws-amplify/ui-react";
import { LanguageContextProvider } from "./LanguageContextProvider";

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root container #root missing in index.html");
}
const root = createRoot(container);

if (isPlaceholderConfig) {
  // eslint-disable-next-line no-console
  console.warn(
    "[gbfdx] amplify_outputs.json is a placeholder; Amplify is unconfigured. " +
      "Run `ampx generate outputs --branch dev` (or `ampx sandbox --once " +
      "--identifier gbfdx-val`) to populate it.",
  );
  root.render(
    <pre
      style={{
        padding: 24,
        margin: 24,
        color: "#900",
        background: "#fff8f8",
        border: "1px solid #f0c0c0",
        borderRadius: 4,
        fontFamily:
          "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace",
        fontSize: 14,
        lineHeight: 1.5,
        whiteSpace: "pre-wrap",
      }}
    >
      {`viewer-client/src/amplify_outputs.json is the placeholder shape;
the Amplify SDK is unconfigured.

To configure for the dev sandbox:
  1. ampx sandbox --once --identifier gbfdx-val
  2. make viewer-bootstrap-outputs
  3. restart the dev server

Or to fetch a specific Amplify Hosting branch's outputs directly:
  ampx generate outputs --branch dev --out-dir viewer-client/src

Until amplify_outputs.json points at a real backend, the
Authenticator and the data-layer client cannot reach AppSync,
Cognito, or S3.`}
    </pre>,
  );
} else {
  root.render(
    <React.StrictMode>
      <CssBaseline>
        <Authenticator.Provider>
          <LanguageContextProvider>
            <App />
          </LanguageContextProvider>
        </Authenticator.Provider>
      </CssBaseline>
    </React.StrictMode>,
  );
}
